import { AdsClick } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";
import React from "react";

/**
 * Audience icon using MUI AdsClick icon.
 * Uses currentColor to inherit MUI theme colors.
 */
const AudienceLabIcon: React.FC<SvgIconProps> = (props) => {
  return <AdsClick {...props} />;
};

export default AudienceLabIcon;
